import { getMenuUnificationFeatureFlag } from './session-storage';

export const getMenuVersion = (getState: Function) => {
  const { restaurant, taskRouter, menu, cachedMenu } = getState();
  const { selectedMenuVersion, prodLiveVersion, menuVersions } = menu || {};

  const isBrandMenu = getMenuUnificationFeatureFlag();

  let prpMenuVersion = '',
    prpMenuTitle = '',
    brandMenuVersion = '';

  if (isBrandMenu) {
    const restaurantCode = restaurant.selectedRestaurantDetails?.restaurantCode;
    const cachedEntry = cachedMenu.brandMenusOrder?.find(
      ({ restaurantId }: { restaurantId: string }) =>
        restaurantId === restaurantCode
    );

    const { menuVersion = '' } = cachedEntry || {};
    brandMenuVersion = menuVersion;
  } else {
    if (taskRouter?.currentTaskId) {
      const restaurantCode =
        restaurant.selectedRestaurantDetails?.restaurantCode;
      const cachedEntry = cachedMenu.menusOrder?.find(
        ({ restaurantId }: { restaurantId: string }) =>
          restaurantId === restaurantCode
      );

      const { menuVersion = '', menuTitle = '' } = cachedEntry || {};
      prpMenuVersion = menuVersion;
      prpMenuTitle = menuTitle;
    } else if (['', 'latest'].includes(selectedMenuVersion)) {
      const { commitId = '', comment = '' } = prodLiveVersion || {};

      prpMenuVersion = commitId;
      prpMenuTitle = comment;
    } else if (selectedMenuVersion) {
      prpMenuVersion = selectedMenuVersion;
      prpMenuTitle =
        menuVersions.find(
          ({ commitId }: { commitId: number }) =>
            commitId === selectedMenuVersion
        )?.comment || '';
    }
  }

  return {
    isBrandMenu,
    prpMenuVersion,
    prpMenuTitle,
    brandMenuVersion,
    menuVersion: isBrandMenu ? brandMenuVersion : prpMenuVersion,
  };
};
